import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import './Aside.scss'

const Aside = ({ leftLink, rightLink, upLink, downLink, backLink, okLink }) => {
    return (
        <div className="A1-side">
            <Link to="/">
                <div className="home-button"></div>
            </Link>
            {rightLink && (
                <Link to={rightLink}>
                    <div className="right-button"></div>
                </Link>
            )}
            {leftLink && (
                <Link to={leftLink}>
                    <div className="left-button"></div>
                </Link>
            )}
            {upLink && (
                <div onClick={upLink}>
                    <div className="up-button"></div>
                </div>
            )}
            {downLink && (
                <div onClick={downLink}>
                    <div className="down-button"></div>
                </div>
            )}
            {backLink && (
                <Link to={backLink}>
                    <div className="back-button"></div>
                </Link>
            )}
            {okLink && (
                <Link to={okLink}>
                    <div className="ok-button"></div>
                </Link>
            )}
            <img src="/images/daljinski.png" className="A1-remote" alt="Daljinski" />
        </div>
    )
}

export default Aside

Aside.propTypes = {
    leftLink: PropTypes.string,
    rightLink: PropTypes.string,
    upLink: PropTypes.func,
    downLink: PropTypes.func,
    backLink: PropTypes.string,
    okLink: PropTypes.string
}
